const localStorageService = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key)
    } catch {
      // do nothing
    }
  },
  setItem: (key, value) => {
    try {
      return localStorage.setItem(key, value)
    } catch {
      //do nothing
    }
  },
  removeItem: (key) => {
    try {
      return localStorage.removeItem(key)
    } catch {
      //do nothing
    }
  }
}

export default localStorageService
